import { createSelector } from 'reselect';
import { connect } from 'react-redux';

/* actions */
import { getList } from '@store/dashboards/list/actions';
import { changeSaveDashboardPromptVisibility } from '@store/dashboards/ui/actions';
import { createDashboard } from '@store/dashboards/create/actions';
import { updateDashboard } from '@store/dashboards/update/actions';

/* selectors */
import { listSelector, listLoaderSelector } from '@store/dashboards/list/selectors';
import { createLoaderSelector } from '@store/dashboards/create/selectors';
import { updateLoaderSelector } from '@store/dashboards/update/selectors';
import { tabsSelector } from '@store/dashboards/tabs/selectors';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import { selectors as dashboardsUIStoreSelector } from '@store/dashboards/ui';

import Navigator from './Navigator';

const selector = createSelector(
  listSelector,
  tabsSelector,
  tabsStoreSelector,
  dashboardsUIStoreSelector,
  listLoaderSelector,
  createLoaderSelector,
  updateLoaderSelector,
  (
    list,
    tabs,
    tabsStore,
    dashboardsUIStore,
    listLoader,
    createLoader,
    updateLoader,
  ) => ({
    list,
    tabs,
    tabsStore,
    dashboardsUIStore,
    listLoader,
    createLoader,
    updateLoader,
  }),
);

export default connect(
  selector,
  {
    getList,
    createDashboard,
    updateDashboard,
    changeSaveDashboardPromptVisibility,
  },
)(Navigator);
